import Button from './_button.js'
import Text from './_text.js'
import FlexPane from './_flex-pane.js'
import RotatableImage from './_rotatable-image.js'

export default {
  name: 'QuickNavigationButton',
  values: {
    container: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexDirection: 'column',
            padding: '0 8px 0 0',
          },
        },
      },
    },
    titleLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    subTitleContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    subTitleLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexGrow: 0,
        },
      },
    },
    expandButtonIcon: {
      configSet: RotatableImage,
      configValues: {
        image: {
          src: 'chevron-up',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
